import { MapDrawDeletedEventData } from './map-draw-deleted-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapDrawDeletedEvent implements MapEvent {
    type = MapEventType.mapDrawDeleted;
    constructor(public payload: MapDrawDeletedEventData) {}
}
